import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { IResource } from '../../services/IResource';
import { DOCUMENT } from '@angular/common';
import { ResourceService } from '../../services/resource.service';
@Component({
  selector: 'app-envisioning-table',
  templateUrl: './envisioning-table.component.html',
  styleUrls: ['./envisioning-table.component.scss']
})
export class EnvisioningTableComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document,
  private resourceService: ResourceService) { }

  @Input() categoryColor;
  @Input() categoryValue: string;
  @Input() categoryLabel;
  @Input() subcategory;
  @Input() pageValue: string;
  @Input() isViewer: boolean;
  @Output() addAttachment = new EventEmitter<string>();
  @Output() editAttachment = new EventEmitter<{categoricalLocation: string, resource: IResource}>();
  @Output() deleteAttachment = new EventEmitter<{resource: IResource, label: string}>();
  private readonly HTTP_PREFIX_RE = /^https?:\/\//i;


  ngOnInit() {
  }

  iconImageSrc(resource: IResource) {
    return `assets/icons/${resource.fileGroupIcon}`;
  }

  altText(resource: IResource) {
    return resource.isUrl ? 'External Link' : 'Attached File';
  }

  getCategoryColor() {
    return { 'background-color' : this.categoryColor };
  }


  onClickAttachmentName(resource: IResource) {
      if (resource.isUrl) {
        if (!resource.resourcePath.match(this.HTTP_PREFIX_RE)) {
          // if the URL is not prefixed with HTTP, then add it.
          resource.resourcePath = `http://${resource.resourcePath}`;
        }
        window.open(resource.resourcePath);
      } else {
        const iframe = this.document.createElement('iframe');
        iframe.src = this.resourceService.transformToResourceDownloadUrl(resource);
        this.document.body.appendChild(iframe);
        setTimeout(() => iframe.remove(), 1000);
      }
    }

  displayEditAttachmentModal(resource: IResource) {
    this.editAttachment.emit({
      categoricalLocation: `${this.pageValue}-${this.categoryValue}`,
      resource: resource
    });
  }

  displayAttachmentModal() {
    this.addAttachment.emit(`${this.pageValue}-${this.categoryValue}`);
  }

  displayDeleteModal(resource: IResource, label: string) {
    this.deleteAttachment.emit({resource: resource, label: label});
  }

  formattedDate(dateStr: string) {
    if (dateStr && dateStr !== '') {
      const isoFormatted = `${dateStr.replace(' ', 'T')}Z`;
      const dateObj = new Date(isoFormatted);
      return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    }
    return '';
  }



  isPlaceholder(attachment: IResource) {
    const keys = Object.keys(attachment);
    return keys.length === 1;
  }

}
